import ReactDOM from "react-dom";
import { ChildrenProps } from "../types";
const id = Number(Math.random().toString().replace("0.", "")).toString(16);
const div = document.createElement("div");
div.id = id;
document.body.appendChild(div);
export default function Portal({ children }: ChildrenProps) {
  return ReactDOM.createPortal(children, div);
}
